import React from "react";
import SectionHeader from "../components/SectionHeader";

const StudentAmbassadorsSection = ({ data }) => (
    <section
        className="student-ambassadors"
        id="student-ambassadors"
    >

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 AMBASSADORS
            ================================================== */}

            <div className="ambassador-grid">

                {(data.items || []).map((item, i) => (

                    <article
                        className="ambassador-card"
                        key={item.id || i}
                    >

                        {item.photo && (
                            <div className="ambassador-photo">

                                <img
                                    src={item.photo}
                                    alt={item.alt || item.name}
                                />

                            </div>
                        )}

                        <div className="ambassador-content">

                            <h3>
                                {item.name}
                            </h3>

                            {item.university && (
                                <p className="ambassador-university">
                                    {item.university}
                                </p>
                            )}

                            {item.program && (
                                <p className="ambassador-program">
                                    {item.program}
                                </p>
                            )}

                            {item.country && (
                                <p className="ambassador-country">
                                    {item.country}
                                </p>
                            )}

                            {item.bio && (
                                <p className="ambassador-bio">
                                    {item.bio}
                                </p>
                            )}

                            {item.linkedin && (
                                <div className="ambassador-links">

                                    <a
                                        href={item.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        LinkedIn
                                    </a>

                                </div>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default StudentAmbassadorsSection;